/**
 * Chat Hooks Index
 *
 * Client-side React hooks for chat functionality.
 * All hooks use TanStack Query for caching and Supabase Realtime for live updates.
 */

// Current user hook (shared auth state)
export { useCurrentUser, type CurrentUser } from './use-current-user';

// Conversation hooks
export {
  useConversations,
  useConversation,
  useTotalUnreadCount,
} from './use-conversations';

// Message hooks
export { useMessages, useMessage } from './use-messages';

// Send/Edit/Delete message hooks
export {
  useSendMessage,
  useEditMessage,
  useDeleteMessage,
} from './use-send-message';

// Reaction hooks
export {
  useReactions,
  useToggleReaction,
  useHasReacted,
} from './use-reactions';

// Realtime subscription hooks
export {
  useChatRealtime,
  useGlobalChatNotifications,
} from './use-chat-realtime';

// Mark as read hooks
export { useMarkAsRead, useMarkAllAsRead } from './use-mark-as-read';

// Presence hooks
export { usePresence, useIsUserOnline } from './use-presence';
export { useUserStatus } from './use-user-status';
